import React, { useState } from 'react';
import { Button, FormControl, Stack, Typography } from '@mui/material';

import { useTranslation } from '../../../contexts/TranslationContext';
import { findValues } from '../../../utils/form';
import ModalEntryList from './modal-list';
import { FormFieldProps } from './index';
import { useFormErrors } from '../../../contexts/FormContext';
import { FormValues } from '../../form/types';

export default function ModalFormField({
    type,
    name,
    label,
    value,
    required,
    disabled,
    onChange,
    children,
    cssClassName,
    help,
    hasTimePublishing = false,
    attr,
    inCmsEdit = false,
    locale,
    formType,
    ...props
}: FormFieldProps) {
    const { translate } = useTranslation();

    const [entryCount, setEntryCount] = useState(value?.length ?? 0);
    const [modalOpen, setModalOpen] = useState(false);

    const { error } = useFormErrors(name);

    const sortable = Boolean(attr?.sortable);

    const onOpen = () => {
        setModalOpen(true);
    };

    const onClose = (newRows: Array<FormValues>) => {
        onChange(newRows ?? []);
        setEntryCount(newRows?.length ?? 0);
        setModalOpen(false);
    };

    const items = findValues(value);

    return (
        <FormControl fullWidth className={cssClassName}>
            <Button
                fullWidth
                variant={error ? 'contained' : 'outlined'}
                size="large"
                disabled={disabled}
                color={error ? 'error' : 'primary'}
                sx={{ justifyContent: 'flex-start', p: 1.5 }}
                onClick={onOpen}>
                <Stack direction="row" spacing={2} alignItems="center">
                    <Typography
                        textTransform="none"
                        color="text.secondary"
                        lineHeight={1}>
                        {translate(label)}
                    </Typography>
                    <Typography
                        textTransform="none"
                        lineHeight={1}
                        variant="caption"
                        color="text.secondary">
                        {`${entryCount} ${translate('form.general.entries')}`}
                    </Typography>
                </Stack>
            </Button>
            <ModalEntryList
                open={modalOpen}
                items={items}
                onClose={onClose}
                fieldConfig={{
                    type,
                    name,
                    label,
                    required,
                    children,
                    attr,
                    ...props,
                }}
                formType={formType}
                value={value}
                error={error}
                hasTimePublishing={hasTimePublishing}
                sortable={sortable}
                inCmsEdit={inCmsEdit}
                locale={locale}
            />
        </FormControl>
    );
}
